<template>
<div class="odr-row__col"
     :class="{
         'odr-row__col_fixed': fixed === 'true',
         'odr-row__col_half': half === 'true',
         'odr-row__col_no-margin': noMargin === 'true',
         'odr-row__col_half-margin': halfMargin === 'true'
     }">
    <slot></slot>
</div>
</template>
<script>
export default {
    props: {
        fixed: {
            _descr: 'Fixed size for column',
        },
        noMargin: {
            _descr: 'Remove margin between columns',
        },
        halfMargin: {
            _descr: 'Margins has half of their origin size',
        },
        half: {
            _descr: 'Gets only half of space',
        },
    },
}
</script>
